import { FaUser } from '@react-icons/all-files/fa/FaUser';
import { FaPhone } from '@react-icons/all-files/fa/FaPhone';
import { FaBriefcase } from '@react-icons/all-files/fa/FaBriefcase';
import { FaRegLightbulb } from '@react-icons/all-files/fa/FaRegLightbulb';
import { FaGraduationCap } from '@react-icons/all-files/fa/FaGraduationCap';
import { FaRegFileAlt } from '@react-icons/all-files/fa/FaRegFileAlt';
import {FaLanguage} from '@react-icons/all-files/fa/FaLanguage';
export const STEPS = [
  { key: 'personal', label: 'Personal details', icon: FaUser },
  { key: 'contact', label: 'Contact information', icon: FaPhone },
  { key: 'employment', label: 'Employment history', icon: FaBriefcase },
  { key: 'skills', label: 'Skills', icon: FaRegLightbulb },
  { key: 'education', label: 'Education', icon: FaGraduationCap },
  { key: 'language', label: 'Languages', icon: FaLanguage },
  { key: 'summary', label: 'Professional summary', icon: FaRegFileAlt },
];
